import Vue from "vue";
import {API_HOST} from "@/settings/server";
import $store from "../store";
import PrintJs from 'print-js'
import {Default} from "../enums/user.type";
import axios from "axios";

class MailService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }
    get({
    skip, limit, sort, desc, uid, inn, unitId, users, receiver, region, area,
    creatorUser,
    senderUser,
    isSent,
    createdStart,
    createdEnd,
    sentStart,
    sentEnd,
    pagesCount,
    pagesCountGt,
    pagesCountLt,
    pagesCountGte,
    pagesCountLte,
    isPerformed,
    sendStatus,
    performType
}) {

    console.log("createdStart value:", createdStart);
    console.log("createdEnd value:", createdEnd);

    let endPoint = $store.getters.appLogin.type === Default ? '/api/mail' : '/api/AdminMail';
    return Vue.axios.get(`${API_HOST}${endPoint}`, {
        headers: {
            'Authorization': `Bearer ${$store.getters.accessToken}`
        },
        params: {
            limit,
            skip,
            sort,
            desc,
            uid: typeof (uid) === "string" ? uid : null,
            inn:  typeof (inn) === 'string' ? inn : null,
            unitId: unitId ? unitId : null,
            receiver: typeof (receiver) === 'string' ? receiver : null,
            region: region ? region.id : null,
            area: area ? area.id : null,
            users,
            sendStatus,
            creatorUser: creatorUser || null,
            senderUser: senderUser ? senderUser.id : null,
            isSent: typeof (isSent) === 'boolean' ? isSent : null,

            createdStart: createdStart && createdStart !== "" ? createdStart.format('YYYY-MM-DD') : null,
            createdEnd: createdEnd && createdEnd !== "" ? createdEnd.format('YYYY-MM-DD') : null,

            sentStart: sentStart ? sentStart.format('YYYY-MM-DD') : null,
            sentEnd: sentEnd ? sentEnd.format('YYYY-MM-DD') : null,

            pagesCount: pagesCount ?? null,
            pagesCountGt: pagesCountGt ?? null,
            pagesCountLt: pagesCountLt ?? null,
            pagesCountGte: pagesCountGte ?? null,
            pagesCountLte: pagesCountLte ?? null,

            isPerformed: typeof (isPerformed) === 'boolean' ? isPerformed : null,
            performType: performType ? performType.id : null,
        },
        cancelToken: this.cancelTokenSource.token,
    })
}


    getSingle(id) {
        return Vue.axios.get(`${API_HOST}/api/mail`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: id
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    delete(id) {
        let params = {id: id}
        return Vue.axios.delete(`${API_HOST}/api/mail`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: params
        })
    }

    async deleteMany(ids) {
        try {
            const response = await Vue.axios.delete(`${API_HOST}/api/mail/delete-many`, {
                headers: {
                    'Authorization': `Bearer ${$store.getters.accessToken}`
                },
                data: ids
            });
            return response.data;
        } catch (error) {
            console.error('Error deleting mails:', error);
            throw error;
        }
    }

    getSendHashCode(id) {
        return Vue.axios.get(`${API_HOST}/api/SendMail`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: id
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    send({id, signature}) {
        return Vue.axios.put(`${API_HOST}/api/SendMail`, {
                Signature: signature
            },
            {
                headers: {
                    'Authorization': `Bearer ${$store.getters.accessToken}`
                },
                params: {
                    id: id
                }
            })
    }

    sendToQueue({id, signature}) {
        return Vue.axios.put(`${API_HOST}/api/SendMailToQeueu`, {
                Signature: signature
            },
            {
                headers: {
                    'Authorization': `Bearer ${$store.getters.accessToken}`
                },
                params: {
                    id: id
                }
            })
    }

    getPdfPath(id) {
        return Vue.axios.get(`${API_HOST}/api/PdfMail/${id}`,{
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    async checkAccess(id) {
        await Vue.axios.get(`${API_HOST}/api/CheckAccess/${id}`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        }).then(function (response) {
            return response.status === 200
        })
    }

    async checkOrganizationIsActive() {
        try {
            await Vue.axios.get(`${API_HOST}/api/CheckOrganizationActive`, {
                headers: {
                    'Authorization': `Bearer ${$store.getters.accessToken}`
                },
                cancelToken: this.cancelTokenSource.token,
            });

            return true;
        } catch (error) {
            if (error.response.data.UserUnitIsActive === false) {
                throw new Error('UserUnitIsActive');
            } else if (error.response.data.UnitContractDateExpired === true) {
                throw new Error('UnitContractDateExpired');
            } else {
                throw error;
            }
        }
    }



    printPdf(id) {
        const promise = Vue.axios.get(`${API_HOST}/api/Receipt`, {
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {id: id},
            cancelToken: this.cancelTokenSource.token,
        });

        promise.then(response => {
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            PrintJs(url);
        });

        return promise;
    }
}

export default new MailService()
